import React, { useState, useMemo } from 'react'
import Filters from '../../../components/Filters/Filters'
import Button from '../../../components/Button/Button'
import './DashboardFilter.css'
// PDF generation
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'

const DashboardFilter = ({
  onApplyFilters,
  onDownload,
  chartRef,
  includeYearFilter = false, 
  yearOptions: yearOptionsProp,
  section,
  dynamicHeight = false, 
  onDownloadStart, 
  onDownloadEnd,
  timeout
}) => {
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);

  const yearOptions = useMemo(() => {
    if (yearOptionsProp && Array.isArray(yearOptionsProp)) return yearOptionsProp;
    const current = new Date().getFullYear();
    const from = current - 6;
    const arr = [];
    for (let y = current; y >= from; y--) arr.push({ label: String(y), value: y });
    return arr;
  }, [yearOptionsProp]);

  const generatePDF = async () => {
  if (typeof onDownloadStart === 'function') onDownloadStart();
  setIsGeneratingPDF(true);

  // Espera a que el contenido se renderice
  await new Promise(resolve => setTimeout(resolve, timeout || 1000));

  if (!chartRef || !chartRef.current) {
    console.error('No chart reference provided');
    setIsGeneratingPDF(false);
    if (typeof onDownloadEnd === 'function') onDownloadEnd();
    return;
  }

  try {
    const chartElement = chartRef.current;
    const canvas = await html2canvas(chartElement, {
      scale: 2,
      useCORS: true,
      logging: false,
      allowTaint: true
    });

    const imgData = canvas.toDataURL('image/png');

    if (dynamicHeight) {
      const imgWidthPx = canvas.width;
      const imgHeightPx = canvas.height;
      const pxToMm = 0.264583;
      const pdfWidth = imgWidthPx * pxToMm;
      const pdfHeight = imgHeightPx * pxToMm;
      const pdf = new jsPDF('p', 'mm', [pdfWidth, pdfHeight]);

      pdf.setFontSize(16);
      pdf.text('Report - ' + new Date().toLocaleDateString(), pdfWidth / 2, 15, { align: 'center' });
      pdf.addImage(imgData, 'PNG', 0, 25, pdfWidth, pdfHeight - 25);
      pdf.save(`dashboard-report-${new Date().toISOString().slice(0, 10)}.pdf`);
    } else {
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      const pdf = new jsPDF('p', 'mm', 'a4');
      pdf.setFontSize(16);
      pdf.text('Report - ' + new Date().toLocaleDateString(), 105, 15, { align: 'center' });
      pdf.addImage(imgData, 'PNG', 0, 25, imgWidth, imgHeight);
      pdf.save(`dashboard-report-${new Date().toISOString().slice(0, 10)}.pdf`);
    }

    if (typeof onDownload === 'function') onDownload();

  } catch (error) {
    console.error('Error al generar el PDF:', error);
  } finally {
    setIsGeneratingPDF(false);
    if (typeof onDownloadEnd === 'function') onDownloadEnd();
  }
};


  const baseFilters = [
    {
      id: 'period',
      label: 'Periods',
      type: 'dropdown',
      options: [
        {label: 'Daily', value: 'day'},
        {label: 'Weekly', value: 'week'},
        {label: 'Monthly', value: 'month'},
        {label: 'Quarterly', value: 'quarter'},
        {label: 'Semesterly', value: 'semester'},
        {label: 'Yearly', value: 'year'}
      ]
    },
    {
      id: 'rangeDate',
      label: 'Date of request',
      type: 'dateRange',
      placeholder: 'dd/mm/yyyy - dd/mm/yyyy'
    }
  ];

  const filtersToRender = useMemo(() => {
    let filters = [];
    
    if (section !== 'rankings') {
      filters.push(baseFilters[0]); // period filter
    }
    
    if (includeYearFilter) {
      filters.push({ 
        id: 'years', 
        label: 'Years', 
        type: 'multi-select', 
        options: yearOptions, 
        placeholder: 'Select one or more years' 
      });
    }
    
    filters.push(baseFilters[1]); 
    
    return filters;
  }, [includeYearFilter, yearOptions, section]);

  return (
    <div className="filters-container-dashboard">
      <Filters filters={filtersToRender} onApplyFilters={onApplyFilters} />
      <div className="download-button-dashboard">
        <Button
          variant="warning"
          children={isGeneratingPDF ? "Generating..." : "Download"}
          borderRadius={10}
          fullWidth={false}
          disabled={isGeneratingPDF}
          onClick={generatePDF}
        />
      </div>
    </div>
  )
}

export default DashboardFilter